import type { AvatarProps } from '@mui/material';

import { tss } from 'tss-react/mui';

import { Or2Image } from '../image/Or2Image';
import { Or2Avatar } from '../Avatar/Or2Avatar';

export interface KeyAvatarProps extends AvatarProps {
  size?: number;
}

export const KEY_LOGO =
  'https://static.governorhub.com/assets/images/ksg_logo_k_blue.png';

const useStyles = tss
  .withParams<{ size: number }>()
  .create(({ theme, size }) => {
    return {
      ksgBadge: {
        width: size,
        height: size,
        border: `2px solid ${theme.palette.background.paper}`,
        backgroundColor: theme.palette.background.paper,
      },
    };
  });

export const KeyAvatar = ({
  size = 15,
  className,
  alt = 'The Key Logo',
  ...other
}: KeyAvatarProps) => {
  const themeProps = { size };
  const { classes, cx } = useStyles(themeProps);

  return (
    <Or2Avatar className={cx(classes.ksgBadge, className)} {...other}>
      <Or2Image src={KEY_LOGO} alt={alt} size={size} />
    </Or2Avatar>
  );
};
